export function isTouchEnabled() {
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);
}

export function initContactForm(containerSelector = '.contact-form') {
  $('body').on('submit', `${containerSelector} form`, function f(e) {
    e.preventDefault();
    const $currentForm = $(this);
    $currentForm.find('button[type=submit]').attr('disabled', true);
    $.ajax({
      type: $currentForm.attr('method'),
      url: $currentForm.attr('action'),
      data: $currentForm.serialize(),
      dataType: 'json',
    })
      .done((data) => {
        $currentForm.parent().html(data.html);
        if (typeof data.ok !== 'undefined' && data.ok) {
          $(':input', `${containerSelector} form`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .removeAttr('checked')
            .removeAttr('selected');
        }
        $currentForm.find('button[type=submit]').removeAttr('disabled');
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        if (typeof jqXHR.responseJSON !== 'undefined') {
          if (jqXHR.responseJSON.hasOwnProperty('form')) {
            $(containerSelector).html(jqXHR.responseJSON.form);
          }
          $(containerSelector).append(jqXHR.responseJSON.message);
        } else {
          alert(errorThrown);
        }
        $currentForm.find('button[type=submit]').removeAttr('disabled');
      });
  });
}

export default function def() {
  initContactForm();
}
